import React, {Component} from 'react';
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import {formatToDollar, runAfterLoadSession, summarizeString} from "../../utils/Utility";
import {sessionDestroy, sessionUpdate} from "../../history/Session";
import {NavLink} from "react-router-dom";
import {elastic as Menu} from 'react-burger-menu'
import Loading from "../shared/Loading";
import {
    acceptTask,
    cancelSearch,
    cancelTaskByTutor,
    changeStatus,
    confirmTaskByStudent,
    getCategoryList,
    getCurrentTaskNeedScore,
    getCurrentTaskStudent,
    getCurrentTaskTutor,
    payForBangladesh,
    rejectAnswerTaskByStudent,
    rejectTask,
    tryPay,
    trySearch
} from "../../utils/API";
import {set} from "../../redux/Action";
import QuestionModal from "../utils/QuestionModal";
import KeyVal from "../shared/KeyVal";
import {show} from "../../utils/Toast";
import {educationLevels} from "../register/Register";
import {history} from "../../history/History";
import logo from "../../images/logo-black.png";
import Modal from "react-bootstrap/Modal";

// const stripePromise = loadStripe('pk_live_4C1NJaevrhgUgFm14yyTLlzS');

class HomeApp extends Component {

    constructor(props) {
        super(props);

        this.state = {
            statusApi: false,
            showOffline: false,
            studentTasks: [],
            pendingTutorTasks: [],
            doingTutorTasks: [],
            showCancelSearch: false,
            showRejectAnswer: false,
            cancelApi: false,
            acceptApi: false,
            currentTask: undefined,
            categoryTutor: undefined,
            taskReject: undefined
        }
    }

    componentDidMount() {
        runAfterLoadSession(() => {
            if (this.props.tutorEnv)
                getCategoryList((res) => {
                    this.setState({categoryTutor: res})
                })
            else {
                this.getCurrentTaskNeedScore()
            }

            this.getPendingRequest()
            let interval = setInterval(() => {
                this.getPendingRequest()
            }, 10000)
            this.setState({interval: interval})
        })

    }

    getPendingRequest = () => {
        if (!this.props.tutorEnv) {
            getCurrentTaskStudent((res) => {
                this.setState({studentTasks: res})
            })
        } else {
            getCurrentTaskTutor((res) => {
                this.setState({pendingTutorTasks: res.pending, doingTutorTasks: res.doing})
            })
        }
    }

    componentWillUnmount() {
        if (this.state.interval)
            clearInterval(this.state.interval)
    }

    toggleStatus = (force) => {
        if (!force && this.props.profile.online) {
            this.setState({showOffline: true})
            return
        }
        this.setState({statusApi: true})
        changeStatus(!this.props.profile.online, () => {
            this.props.dispatch(set(Objects.profile, {
                ...this.props.profile,
                online: !this.props.profile.online
            }))
            this.setState({statusApi: false, showOffline: false})
        })
    }

    getStatus = (status, isBangladesh) => {
        if (status === 'SEARCHING')
            return ['Searching', '#ffab4f']
        else if (status === 'ACCEPT_BY_TUTOR')
            return [isBangladesh ? 'Accepted by tutor, please pay the task fee' : 'Accepted by tutor, please wait for payment confirmation', '#ffab4f']
        else if (status === 'PAYMENT_SUCCESS_AND_DOING')
            return ['Tutor is working on the task', '#4ea047']
        else if (status === 'PAYMENT_UNSUCCESSFUL')
            return ['Payment was unsuccessful, please check entered card information', '#cb0c19']
        else if (status === 'FINISH_TUTOR')
            return ['Marked as completed by the tutor', '#3e97c7']
        else if (status === 'FINISH_STUDENT')
            return ['Marked as completed by you', '#3e97c7']
        else if (status === 'CANCEL_BY_STUDENT')
            return ['Cancelled by you', '#cb0c19']
        else if (status === 'CANCEL_BY_TUTOR')
            return ['Cancelled by tutor', '#cb0c19']
        else if (status === 'NOT_FINDING_TUTOR')
            return ['Did not find any tutors. You can try again', '#ffab4f']
        else
            return ['Unknown', '#000']
    }

    getStatusTutor = (status) => {
        if (status === 'SEARCHING')
            return ['Unknown', '#ffab4f']
        else if (status === 'ACCEPT_BY_TUTOR')
            return ['You accepted the request, please wait for the student to pay the task fee', '#ffab4f']
        else if (status === 'PAYMENT_SUCCESS_AND_DOING')
            return ['The student has made a payment, you can start working on the task', '#4ea047']
        else if (status === 'PAYMENT_UNSUCCESSFUL')
            return ['Payment was unsuccessful, please wait for the student to pay the task fee', '#cb0c19']
        else if (status === 'FINISH_TUTOR')
            return ['You have requested to mark the task as compeleted, please wait for the student confirm', '#3e97c7']
        else if (status === 'FINISH_STUDENT')
            return ['Task is completed', '#3e97c7']
        else if (status === 'CANCEL_BY_STUDENT')
            return ['Task is cancelled by the student', '#cb0c19']
        else if (status === 'CANCEL_BY_TUTOR')
            return ['Task is cancelled by you', '#cb0c19']
        else if (status === 'NOT_FINDING_TUTOR')
            return ['Unknown', '#ffab4f']
        else
            return ['Unknown', '#000']
    }

    cancelSearch = () => {
        this.setState({
            cancelApi: true
        })
        cancelSearch(this.state.currentTask.hashId, (res) => {
            this.setState({
                cancelApi: false,
                showCancelSearch: false,
                studentTasks: res
            })
            show("Task search canceled")
        }, () => {
            this.setState({
                cancelApi: false,
                showCancelSearch: false,
            })
        })
    }
    cancelTask = (taskHashId) => {
        this.setState({
            cancelApi: true
        })
        cancelTaskByTutor(taskHashId, (res) => {
            this.setState({
                cancelApi: false,
                taskCancel: undefined,
                pendingTutorTasks: res.pending,
                doingTutorTasks: res.doing,
            })
            show("Task canceled")
        }, () => {
            this.setState({
                cancelApi: false,
                taskCancel: undefined,
            })
        })
    }

    trySearch = (taskHashId) => {
        this.setState({
            cancelApi: true
        })
        trySearch(taskHashId, (res) => {
            this.setState({
                cancelApi: false,
                studentTasks: res
            })
        }, () => {
            this.setState({
                cancelApi: false,
            })
        })
    }

    tryForPay = (taskHashId) => {
        this.setState({
            cancelApi: true
        })
        tryPay(taskHashId, (res) => {
            this.setState({
                cancelApi: false,
                studentTasks: res
            })
        }, () => {
            this.setState({
                cancelApi: false,
            })
        })
    }

    confirmTaskByStudent = (taskHashId) => {
        this.setState({
            cancelApi: true
        })
        confirmTaskByStudent(taskHashId, (res) => {
            this.setState({
                cancelApi: false,
                studentTasks: res
            })
            this.getCurrentTaskNeedScore()
        }, () => {
            this.setState({
                cancelApi: false,
            })
        })
    }

    rejectTaskByStudent = (taskHashId) => {
        this.setState({
            cancelApi: true
        })
        rejectAnswerTaskByStudent(taskHashId, (res) => {
            this.setState({
                cancelApi: false,
                studentTasks: res,
                currentTask: undefined,
                showRejectAnswer: false
            })
        }, () => {
            this.setState({
                cancelApi: false,
            })
        })
    }

    getCurrentTaskNeedScore = () => {
        getCurrentTaskNeedScore((res) => {
            if (res) {
                this.props.dispatch(set(Objects.currentTask, res))
                history.push("/hom/score")
            }
        }, () => {
        })
    }

    acceptRejectTask = (accept, taskTutorHashId) => {
        this.setState({
            acceptApi: true,
        })
        if (accept) {
            acceptTask(taskTutorHashId, (res) => {
                this.setState({
                    pendingTutorTasks: res.pending,
                    doingTutorTasks: res.doing,
                    acceptApi: false,
                });
            }, () => {
                this.setState({
                    acceptApi: false,
                })
            })
        } else {
            rejectTask(taskTutorHashId, (res) => {
                this.setState({
                    pendingTutorTasks: res.pending,
                    doingTutorTasks: res.doing,
                    acceptApi: false,
                    taskReject: undefined
                });
            }, () => {
                this.setState({
                    acceptApi: false,
                })
            })
        }
    }


    render() {
        return (
            <div className="">
                <div className="home-header">
                    {this.props.profile && <div>
                        <span>Hello @{this.props.profile.username}!</span>
                        {this.props.tutorEnv && <button
                            className="waves-effect waves-light btn white w-100 no-uppercase shadow-black online-btn"
                            disabled={this.state.statusApi}
                            onClick={() => this.toggleStatus(false)}>
                            <Loading show={this.state.statusApi}>
                            <span
                                className={"black-text " + (this.props.profile.online ? "green-status" : "red-status")}>{this.props.profile.online ? 'Online' : 'Offline'}</span>
                            </Loading>
                        </button>}
                        {
                            !this.props.tutorEnv && <img src={logo} alt=""/>
                        }
                    </div>}
                </div>
                <div className="home-burger">
                    {this.props.profile && <Menu slide>
                        <div className="menu-burger">
                            <NavLink to="/hom/profile">
                                <img src={window.baseFile + this.props.profile.profilePhotoUrl} alt=""/>
                                <span className="profile-name">
                                    @{this.props.profile.username}
                                </span>
                            </NavLink>
                            <span className="profile-intro">
                                    Balance: {this.props.tutorEnv ? formatToDollar(this.props.profile.tutorCredit) : formatToDollar(this.props.profile.studentCredit)}
                                </span>
                            {this.props.tutorEnv && <div className="pr-5 pl-5 mt-3">
                                <button
                                    className="waves-effect waves-light btn white w-100 no-uppercase bold shadow-white"
                                    onClick={() => {
                                        this.setState({showCashOut: true})
                                    }}>
                                    <span className="black-text">Cash Out</span>
                                </button>
                            </div>}
                            <div className="pr-4 pl-4">
                                <div className="thin-border text-center pb-3 pt-3">
                                    <div className="menu-item">
                                        <i className="icon-wallet"/>
                                        <NavLink to="/hom/transaction">Transactions</NavLink>
                                    </div>
                                    <div className="menu-item">
                                        <i className="icon-search"/>
                                        <NavLink to="/hom/task">Tasks</NavLink>
                                    </div>
                                    {!this.props.tutorEnv && <div className="menu-item">
                                        <i className="icon-cart"/>
                                        <NavLink to="/hom/profile">Credit Card</NavLink>
                                    </div>}
                                    {this.props.tutorEnv && <div className="menu-item">
                                        <i className="icon-star"/>
                                        <NavLink to="/hom/category">My Categories</NavLink>
                                    </div>}
                                    {!this.props.tutorEnv && <div className="menu-item">
                                        <i className="icon-star"/>
                                        <NavLink to="/hom/favorite">Favorite Tutors</NavLink>
                                    </div>}
                                    <div className="menu-item">
                                        <i className="icon-phone"/>
                                        <a href="mailto:support@tutorfest.com">Support</a>
                                    </div>
                                    <div className="menu-item">
                                        <i className="icon-information"/>
                                        <NavLink to="/privacy-and-policy">Privacy Us</NavLink>
                                    </div>
                                    <div className="menu-item">
                                        <i className="icon-trash"/>
                                        <NavLink to="/hom/delete-account">Delete Account</NavLink>
                                    </div>
                                </div>
                            </div>
                            <div className="footer-burger">
                                <div className="logout-version">
                                    <button
                                        disabled={this.state.clicked}
                                        className="waves-effect waves-light btn white w-100 no-uppercase bold shadow-white"
                                        onClick={() => {
                                            this.setState({
                                                clicked: true
                                            })
                                            sessionUpdate(Objects.tutorEnv, !this.props.tutorEnv)
                                            setTimeout(() => {
                                                window.location.href = '/hom'
                                            }, 1000)
                                        }}>
                                        <span
                                            className="black-text">{this.props.tutorEnv ? 'Switch to Student' : 'Switch to Tutor'}</span>
                                    </button>
                                    <button
                                        className="waves-effect waves-light btn white w-100 no-uppercase bold shadow-white"
                                        onClick={() => {
                                            sessionDestroy()
                                        }}>
                                        <span className="black-text">Logout</span>
                                    </button>
                                    <div className="version">
                                        <span>{process.env.REACT_APP_VERSION}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Menu>}
                </div>
                <div className="main-app">
                    {!this.props.tutorEnv && <div>
                        <div className="text-center pt-2">
                            <span className="bold">Requested Task</span>
                        </div>
                        <div className="mt-3 body-app">
                            <div>
                                {
                                    this.state.studentTasks.map((task) => <div key={task.hashId}
                                                                               className="shadow-black mb-3 p-3">
                                        <div className="text-center">
                                            <h5>{task.title}</h5>
                                        </div>
                                        <div className="text-center mt-2 mb-1">
                                            <span className="bold"
                                                  style={{color: this.getStatus(task.status)[1]}}>{this.getStatus(task.status,this.props.profile.countryName === 'Bangladesh')[0]}</span>
                                        </div>
                                        {task.status === 'ACCEPT_BY_TUTOR' && this.props.profile.countryName === 'Bangladesh' && <div className="text-center mt-2 mb-1">
                                            <button
                                                disabled={this.state.payApi}
                                                className="waves-effect waves-light btn green no-uppercase"
                                                onClick={() => {
                                                    this.setState({payApi: true})
                                                    payForBangladesh(task.hashId,(res) => {
                                                        if(res !== undefined){
                                                            window.location.href = res
                                                        }
                                                        else
                                                            this.setState({payApi: false})
                                                    })
                                                }}>
                                                <Loading show={this.state.payApi}>
                                                    <span className="white-text">Pay Fee</span>
                                                </Loading>
                                            </button>
                                        </div>}
                                        {task.status === 'PAYMENT_UNSUCCESSFUL' &&
                                        <div className="mt-2 mb-2 text-center">
                                            <NavLink className="grey-text border-bottom" to="/hom/profile">Click here to
                                                edit card</NavLink>
                                        </div>}
                                        <div className="d-flex flex-column">
                                            <KeyVal name="Field:" value={task.field.name}/>
                                            <KeyVal name="Category:" value={task.category.name}/>
                                            <KeyVal name="Due:"
                                                    value={new Date(task.deadline).toLocaleDateString("en-US")}/>
                                            <KeyVal name="Amount:" value={formatToDollar(task.totalAmount)}/>
                                        </div>
                                        {task.tutor && <div>
                                            <div className="border-bottom mb-2 pt-2"/>
                                            <div className="text-center">
                                                <h5>Tutor</h5>
                                            </div>
                                            <div className="d-flex flex-row">
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <img alt="" className="img-circle"
                                                         src={window.baseFile + task.tutor.profilePhotoUrl}/>
                                                </div>
                                                <div
                                                    className="d-flex pl-2 w-100 flex-row justify-content-between align-items-center">
                                                    <span>{task.tutor.username}</span>
                                                    <span
                                                        className="grey-text">{educationLevels[task.tutor.educationLevelOrdinal].title}</span>
                                                </div>
                                            </div>
                                        </div>}
                                        <div className="mt-3">
                                            {(task.status === 'SEARCHING' || task.status === 'NOT_FINDING_TUTOR' || task.status === 'PAYMENT_UNSUCCESSFUL') &&
                                            <button
                                                className="waves-effect waves-light btn red no-uppercase shadow-black"
                                                onClick={() => this.setState({
                                                    showCancelSearch: true,
                                                    currentTask: task
                                                })}>
                                                <span
                                                    className="white-text">{task.status === 'NOT_FINDING_TUTOR' ? 'Remove task' : 'Cancel search'}</span>
                                            </button>}
                                            {task.status === 'NOT_FINDING_TUTOR' && <button
                                                disabled={this.state.cancelApi}
                                                onClick={() => this.trySearch(task.hashId)}
                                                className="ml-3 waves-effect waves-light btn white no-uppercase shadow-black">
                                                <Loading show={this.state.cancelApi}>
                                                    <span className="black-text">Try again</span>
                                                </Loading>
                                            </button>}
                                            {task.status === 'PAYMENT_UNSUCCESSFUL' && <button
                                                disabled={this.state.cancelApi}
                                                onClick={() => this.tryForPay(task.hashId)}
                                                className="ml-3 waves-effect waves-light btn white no-uppercase shadow-black">
                                                <Loading show={this.state.cancelApi}>
                                                    <span className="black-text">Try for pay</span>
                                                </Loading>
                                            </button>}
                                            {(task.status === 'PAYMENT_SUCCESS_AND_DOING' || task.status === 'FINISH_TUTOR') &&
                                            <div>
                                                <NavLink
                                                    to={'/hom/chat/' + this.props.profile.hashId + "/" + task.tutor.hashId}
                                                    className="waves-effect waves-light btn white no-uppercase shadow-black ml-3">
                                                    <span className="black-text">Chat with Tutor</span>
                                                </NavLink>
                                            </div>}
                                            {task.status === 'FINISH_TUTOR' &&
                                            <div>
                                                <div className="border-bottom mt-2 mb-2 pb-2"/>
                                                <div><span className="bold">Tutor send this files for solution:</span>
                                                </div>
                                                {task.answerFiles !== '' && <div>
                                                    <div className="mt-3 text-center grey-text">
                                                        <span>Uploaded Files</span>
                                                    </div>
                                                    <div className="mt-2">
                                                        {
                                                            task.answerFiles.split("||").map((t, i) => <a
                                                                rel="noopener noreferrer"
                                                                href={window.baseAPI + "/file/download?link=" + t + "&token=" + this.props.token}
                                                                target="_blank" className="d-block mt-1" key={i}>
                                                                <span>{summarizeString(t.split("/")[t.split("/").length - 1], 25)}</span>
                                                                <span className="ml-2 green-text">Download</span>
                                                            </a>)
                                                        }
                                                    </div>
                                                    <div className="mt-3">
                                                    <span>
                                                        If everything is submitted correctly, please confirm the request, otherwise reject the solutions and chat with the tutor.
                                                    </span>
                                                    </div>
                                                    <div className="mt-3">
                                                        <button
                                                            disabled={this.state.cancelApi}
                                                            onClick={() => this.setState({
                                                                currentTask: task,
                                                                showRejectAnswer: true,
                                                            })}
                                                            className="waves-effect waves-light btn red no-uppercase shadow-black">
                                                            <Loading show={this.state.cancelApi}>
                                                                <span className="white-text">Reject</span>
                                                            </Loading>
                                                        </button>
                                                        <button
                                                            disabled={this.state.cancelApi}
                                                            onClick={() => this.confirmTaskByStudent(task.hashId)}
                                                            className="ml-3 waves-effect waves-light btn green no-uppercase shadow-black">
                                                            <Loading show={this.state.cancelApi}>
                                                                <span className="white-text">Confirm</span>
                                                            </Loading>
                                                        </button>
                                                    </div>
                                                </div>}
                                            </div>}
                                        </div>
                                    </div>)
                                }
                                {this.state.studentTasks.length === 0 &&
                                <span className="d-block text-center">There are no requests</span>}
                            </div>
                        </div>
                        {<div className="new-request-btn">
                            <NavLink to="/hom/new-task"
                                     className="waves-effect waves-light btn white no-uppercase shadow-black">
                                <span>New Request</span>
                                <span className="plus">+</span>
                            </NavLink>
                        </div>}
                    </div>
                    }
                    {
                        this.props.tutorEnv && <div>
                            <div className="mt-3 body-app">
                                <div>
                                    {this.state.categoryTutor && this.state.categoryTutor.length === 0 &&
                                    <NavLink className="d-block mt-3 mb-3 notice p-3 shadow-black" to="/hom/category">
                                        <span>You have not selected any categories yet,</span>
                                        <b>click here to add a category</b>
                                        <span className="d-block">To receive a task, you must select at least one category to be sent to you according to the selected category</span>
                                    </NavLink>}

                                    <h5 className="mt-4 mb-2">Requested Tasks</h5>
                                    {this.state.pendingTutorTasks.length === 0 &&
                                    <span className="d-block text-center">There are no tasks requested from you yet</span>}
                                    {
                                        this.state.pendingTutorTasks.map((taskTutor) => {
                                            let task = taskTutor.task;
                                            return (<div key={task.hashId}
                                                         className="shadow-black mb-3 p-3">
                                                <div className="text-center">
                                                    <h5>{task.title}</h5>
                                                </div>
                                                <div className="text-center mt-2 mb-1">
                                                    <p className="mb-1">{this.state['showMore' + task.hashId] ? task.description : summarizeString(task.description, 160)}</p>
                                                    {task.description.length > 160 && <button
                                                        onClick={() => this.setState({['showMore' + task.hashId]: !this.state['showMore' + task.hashId]})}
                                                        className="grey-text border-bottom">{this.state['showMore' + task.hashId] ? 'show less' : 'show more'}</button>}
                                                </div>
                                                <div className="d-flex flex-column">
                                                    <KeyVal name="Field:" value={task.field.name}/>
                                                    <KeyVal name="Category:" value={task.category.name}/>
                                                    <KeyVal name="Due:"
                                                            value={new Date(task.deadline).toLocaleDateString("en-US")}/>
                                                    <KeyVal name="Amount:" value={formatToDollar(task.initialAmount)}/>
                                                </div>
                                                {task.files !== '' && <div>
                                                    <div className="mt-3 text-center grey-text">
                                                        <span>Uploaded Files</span>
                                                    </div>
                                                    <div className="mt-2">
                                                        {
                                                            task.files.split("||").map((t, i) => <a
                                                                rel="noopener noreferrer"
                                                                href={window.baseAPI + "/file/download?link=" + t + "&token=" + this.props.token}
                                                                target="_blank" className="d-block mt-1" key={i}>
                                                                <span>{summarizeString(t.split("/")[t.split("/").length - 1], 25)}</span>
                                                                <span className="ml-2 green-text">show</span>
                                                            </a>)
                                                        }
                                                    </div>
                                                </div>}
                                                <div className="mt-3">
                                                    {task.status === 'SEARCHING' &&
                                                    <div>
                                                        <button
                                                            className="waves-effect waves-light btn red no-uppercase shadow-black"
                                                            onClick={() => this.setState({taskReject: taskTutor})}>
                                                            <span className="black-text white-text">Reject</span>
                                                        </button>
                                                        <button
                                                            className="waves-effect waves-light btn green no-uppercase shadow-black ml-3"
                                                            onClick={() => this.acceptRejectTask(true, taskTutor.hashId)}>
                                                            <span className="black-text white-text">Accept</span>
                                                        </button>
                                                    </div>}
                                                </div>
                                            </div>)
                                        })
                                    }
                                    <h5 className="mt-4 mb-2">Accepted Tasks</h5>
                                    {this.state.doingTutorTasks.length === 0 &&
                                    <span className="d-block text-center">You have not accepted any tasks yet</span>}
                                    {
                                        this.state.doingTutorTasks.map((task) => {
                                            return (<div key={task.hashId}
                                                         className="shadow-black mb-3 p-3">
                                                <div className="text-center">
                                                    <h5>{task.title}</h5>
                                                </div>
                                                <div className="text-center mt-2 mb-1">
                                                    <p className="mb-1">{this.state['showMore' + task.hashId] ? task.description : summarizeString(task.description, 160)}</p>
                                                    {task.description.length > 160 && <button
                                                        onClick={() => this.setState({['showMore' + task.hashId]: !this.state['showMore' + task.hashId]})}
                                                        className="grey-text border-bottom">{this.state['showMore' + task.hashId] ? 'show less' : 'show more'}</button>}
                                                </div>
                                                <div className="text-center mt-2 mb-1">
                                                    <span className="bold"
                                                          style={{color: this.getStatusTutor(task.status)[1]}}>{this.getStatusTutor(task.status)[0]}</span>
                                                </div>
                                                <div className="d-flex flex-column">
                                                    <KeyVal name="Field:" value={task.field.name}/>
                                                    <KeyVal name="Category:" value={task.category.name}/>
                                                    <KeyVal name="Due:"
                                                            value={new Date(task.deadline).toLocaleDateString("en-US")}/>
                                                    <KeyVal name="Amount:" value={formatToDollar(task.initialAmount)}/>
                                                </div>
                                                {task.files !== '' && <div>
                                                    <div className="mt-3 text-center grey-text">
                                                        <span>Uploaded Files</span>
                                                    </div>
                                                    <div className="mt-2">
                                                        {
                                                            task.files.split("||").map((t, i) => <a
                                                                rel="noopener noreferrer"
                                                                href={window.baseAPI + "/file/download?link=" + t + "&token=" + this.props.token}
                                                                target="_blank" className="d-block mt-1" key={i}>
                                                                <span>{summarizeString(t.split("/")[t.split("/").length - 1], 30)}</span>
                                                                <span className="ml-2 green-text">show</span>
                                                            </a>)
                                                        }
                                                    </div>
                                                </div>}
                                                {task.student && <div>
                                                    <div className="border-bottom mb-2 pt-2"/>
                                                    <div className="text-center">
                                                        <h5>Student</h5>
                                                    </div>
                                                    <div className="d-flex flex-row">
                                                        <div
                                                            className="d-flex align-items-center justify-content-center">
                                                            <img alt="" className="img-circle"
                                                                 src={window.baseFile + task.student.profilePhotoUrl}/>
                                                        </div>
                                                        <div
                                                            className="d-flex pl-2 w-100 flex-row justify-content-between align-items-center">
                                                            <span>{task.student.username}</span>
                                                            <span
                                                                className="grey-text">{educationLevels[task.student.educationLevelOrdinal].title}</span>
                                                        </div>
                                                    </div>
                                                </div>}
                                                <div className="mt-3">
                                                    {(task.status === 'PAYMENT_SUCCESS_AND_DOING' || task.status === 'FINISH_TUTOR') &&
                                                    <div>
                                                        {task.status === 'PAYMENT_SUCCESS_AND_DOING' && <button
                                                            className="waves-effect waves-light btn red no-uppercase shadow-black"
                                                            onClick={() => this.setState({taskCancel: task})}>
                                                            <span className="white-text">Cancel task</span>
                                                        </button>}
                                                        <NavLink

                                                            to={'/hom/chat/' + this.props.profile.hashId + "/" + task.student.hashId}
                                                            className="waves-effect waves-light btn white no-uppercase shadow-black ml-3">
                                                            <span className="black-text">Chat With Student</span>
                                                        </NavLink>

                                                        {task.status === 'PAYMENT_SUCCESS_AND_DOING' &&
                                                        <div className="mt-3">
                                                            <button onClick={() => {
                                                                this.props.dispatch(set(Objects.currentTask, task))
                                                                history.push("/hom/send-answer")
                                                            }}
                                                                    className="waves-effect waves-light btn green no-uppercase shadow-black ml-3">
                                                                <span className="white-text">Send Solution</span>
                                                            </button>
                                                        </div>}
                                                    </div>}
                                                </div>
                                            </div>)
                                        })
                                    }
                                </div>
                            </div>

                        </div>
                    }
                </div>
                <QuestionModal show={this.state.showOffline}
                               onHide={() => this.setState({showOffline: false})}
                               acceptTitle="Yes"
                               rejectTitle="No"
                               onReject={() => this.setState({showOffline: false})}
                               hideButton={this.state.statusApi}
                               onAccept={() => this.toggleStatus(true)}
                >
                    <div className="text-center p-3">
                        <span>Are you sure about going offline?</span>
                    </div>
                </QuestionModal>
                <QuestionModal show={this.state.taskReject !== undefined}
                               onHide={() => this.setState({taskReject: undefined})}
                               acceptTitle="Yes"
                               rejectTitle="No"
                               onReject={() => this.setState({taskReject: undefined})}
                               hideButton={this.state.acceptApi}
                               onAccept={() => this.acceptRejectTask(false, this.state.taskReject.hashId)}
                >
                    <div className="text-center p-3">
                        <span>Are you sure about rejecting the task?</span>
                    </div>
                </QuestionModal>
                <QuestionModal show={this.state.taskCancel !== undefined}
                               onHide={() => this.setState({taskCancel: undefined})}
                               acceptTitle="Yes"
                               rejectTitle="No"
                               onReject={() => this.setState({taskCancel: undefined})}
                               hideButton={this.state.cancelApi}
                               onAccept={() => this.cancelTask(this.state.taskCancel.hashId)}
                >
                    <div className="text-center p-3">
                        <span>Are you sure about cancelling the task?</span>
                    </div>
                </QuestionModal>
                <QuestionModal show={this.state.showCancelSearch}
                               onHide={() => this.setState({showCancelSearch: false})}
                               acceptTitle="Yes"
                               rejectTitle="No"
                               onReject={() => this.setState({showCancelSearch: false})}
                               hideButton={this.state.cancelApi}
                               onAccept={this.cancelSearch}
                >
                    <div className="text-center p-3">
                        <span>{this.state.currentTask && this.state.currentTask.status === 'SEARCHING' ? 'Are you sure about canceling the search?' : 'Are you sure about removing the task?'}</span>
                    </div>
                </QuestionModal>
                <QuestionModal show={this.state.showRejectAnswer}
                               onHide={() => this.setState({showRejectAnswer: false})}
                               acceptTitle="Yes"
                               rejectTitle="No"
                               onReject={() => this.setState({showRejectAnswer: false})}
                               hideButton={this.state.cancelApi}
                               onAccept={() => this.rejectTaskByStudent(this.state.currentTask.hashId)}
                >
                    <div className="text-center p-3">
                        <span>{'Are you sure about rejecting the solution?'}</span>
                    </div>
                </QuestionModal>
                <Modal
                    style={{'overflow': 'auto'}}
                    show={this.state.showCashOut}
                    onHide={() => this.setState({showCashOut: false})}
                    centered={true}
                    size={"lg"}
                    className="tutor-toast"
                >
                    <div className="p-3">
                        <div className="text-center">
                            <h4>Cash out</h4>
                        </div>
                        <div className="mt-4 text-center">
                            <span>Cash out is automatically</span>
                            {/*<Elements stripe={stripePromise}>*/}
                            {/*    <ElementsConsumer>*/}
                            {/*        {(ctx) => <div>*/}
                            {/*            <PaymentRequestButtonElement id="" options={{*/}
                            {/*                paymentRequest: {*/}
                            {/*                    isShowing: () => {*/}
                            {/*                    }*/}
                            {/*                },*/}
                            {/*                style: {*/}
                            {/*                    base: {*/}
                            {/*                        backgroundColor: '#000',*/}
                            {/*                        padding: '10px',*/}
                            {/*                        color: '#fff',*/}
                            {/*                        fontSize: "18px",*/}
                            {/*                        "::placeholder": {*/}
                            {/*                            color: "#fff"*/}
                            {/*                        }*/}
                            {/*                    }*/}
                            {/*                }*/}
                            {/*            }}/>*/}
                            {/*            <div className="mt-3" style={{*/}
                            {/*                borderTop: '1px solid #ced4da',*/}
                            {/*            }}>*/}
                            {/*                <button*/}
                            {/*                    onClick={() => console.log(ctx)}*/}
                            {/*                    disabled={this.state.registerApi}*/}
                            {/*                    className="mt-3 waves-effect waves-light btn-large white w-100 no-uppercase bold">*/}
                            {/*                    <Loading show={this.state.registerApi}>*/}
                            {/*                        <span>Update</span>*/}
                            {/*                    </Loading>*/}
                            {/*                </button>*/}
                            {/*            </div>*/}
                            {/*        </div>}*/}
                            {/*    </ElementsConsumer>*/}
                            {/*</Elements>*/}
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.param[Objects.profile],
        token: state.param[Objects.token],
        tutorEnv: state.param[Objects.tutorEnv],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeApp)
